import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import router from "@/router/router.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {Source} from "@/domain/type/source.type.ts";
import {useWorkflowStore} from "@/stores/workflow.store.ts";

export default class SessionConfig extends AbstractType {
  private workflowStore = useWorkflowStore();

  getStepperItems(): StepperItem[] {
    return [
      {
        disabled: false,
        route: RouteEnum.Fusion,
        icon: "mdi-school",
        title: "Action de formation",
        action: () => router.push(this.getRoute(RouteEnum.Fusion))
      },
      {
        disabled: false,
        route: RouteEnum.SyncWithOwner,
        icon: "mdi-calendar-clock",
        title: "Séances",
        action: () => router.push(this.getRoute(RouteEnum.SyncWithOwner))
      }
    ]
  }

  sourceLeftList(): Source[] {
    return [Source.EVA];
  }

  sourceRightList(): Source[] {
    return [Source.AMMON];
  }

  cleanFieldValue(value: string, label: string): string {
    return value;
  }

  private getRoute(routeName: RouteEnum): any {
    switch (routeName) {
      case RouteEnum.Fusion:
        return {
          name: RouteEnum.Fusion,
          params: {
            id: this.workflowStore.courseNumGroup || this.workflowStore.courseId,
            sourceLeft: 'eva',
            sourceRight: 'ammon',
            type: SynchroType.COURSE
          },
          query: {
            _r: Date.now()
          }
        }
      case RouteEnum.SyncWithOwner:
        return {
          name: RouteEnum.SyncWithOwner,
          params: {
            ownerId: this.workflowStore.courseNumGroup || this.workflowStore.courseId,
            type: SynchroType.SESSIONS
          }
        }
    }
  }
}
